import React, { useState } from 'react';
import { Droplet, Globe, ShieldCheck, TrendingUp, Zap, Anchor, Layers, Cpu, MapPin, Phone, Mail, Award, Target, Network, Handshake, Users, Truck, BarChart, BarChart3, CheckCircle, Plane, Construction, Settings, Leaf, AlertCircle, Heart, Map, LineChart } from 'lucide-react';
import './App.css';
import logo from './images/LOGO_AFRICA_GROWTH.png'
import oil_rig from './images/oil_rig.png'
import silhuette_oil_rig from './images/silhuette_oil_rig.png'
import oil_truck from './images/oil_truck.png'
const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <nav className="navbar">
      <div className="container">
        <div className="nav-content">
          <div className="nav-brand">
            <div style={{ width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: "2%"  }}>
               <img src={logo} width={"100px"} alt={"Africa Growth logo"} />
            </div>
            <div className="nav-brand-text">
              <span className="nav-brand-title">Africa Growth Group</span>
              
            </div>
          </div>
          
          <div className="nav-links">
            <a href="#about" className="nav-link">Who We Are</a>
            <a href="#business" className="nav-link">Our Business</a>
            <a href="#products-services" className="nav-link">Products & Services</a>
            <a href="#strategy" className="nav-link">Strategy</a>
            <a href="#contact" className="btn-primary">Contact Us</a>
          </div>
        </div>
      </div>
    </nav>
  );
};

const ImageDivider = ({image}) => (
  <section className="image-divider-section">
    <div className="image-divider-container">
      <img 
        src={image} 
        alt="Oil Rig Silhouette" 
        className="divider-image"
      />
      <div className="fade-overlay-top"></div>
      <div className="fade-overlay-bottom"></div>
    </div>
  </section>
);

const Hero = () => (
  <section className="hero">
    <div className="hero-bg">
      <img src={oil_rig} alt="Africa Growth Oil Rig" />
      <div className="hero-overlay"></div>
    </div>
    <div className="hero-content">
      <h1 className="hero-title">Fueling the <span className="text-accent">African Corridor.</span></h1>
      <p className="hero-text">Bridging the gap between global energy supply and local demand through local intelligence and logistical excellence.</p>
      <a href="#prospects" className="btn-primary">View 2026 Strategy</a>
    </div>
  </section>
);

const Identity = () => (
  <section className="section" style={{ paddingTop: 0 }}>
    <div className="container">
      <div className="vision-mission-box">
        <div>
          <div className="tag">The Vision</div>
          <h2 style={{ fontSize: '1.8rem', marginBottom: '1rem' }}>The Agile Link</h2>
          <p style={{ color: 'var(--cool-grey)', fontSize: '1.1rem' }}>
            To be the most agile and reliable link in the African energy value chain, bridging the gap between global supply and local demand.
          </p>
        </div>
        <div style={{ borderLeft: '1px solid var(--border-grey)', paddingLeft: '3rem' }}>
          <div className="tag">The Mission</div>
          <h2 style={{ fontSize: '1.8rem', marginBottom: '1rem' }}>Seamless Solutions</h2>
          <p style={{ color: 'var(--cool-grey)', fontSize: '1.1rem' }}>
            Leveraging local intelligence and logistical excellence to provide seamless energy solutions across Sub-Saharan Africa.
          </p>
        </div>
      </div>
    </div>
  </section>
);

const Strategy = () => (
  <section id="strategy" className="section section-alt">
    <div className="container">
      <div className="section-header">
        <h2 className="section-title">Market Execution Strategy</h2>
        <div className="title-underline"></div>
      </div>

      <div className="strategy-grid">
        <div className="strategy-card">
          <Globe className="text-accent" size={32} style={{ marginBottom: '1.5rem' }} />
          <h3>Geographical Focus</h3>
          <p style={{ color: 'var(--cool-grey)', marginBottom: '1rem' }}>Utilizing South Africa as a base for landlocked nations (Zimbabwe, Zambia, Botswana) while optimizing East African corridors via Beira and Dar es Salaam. We are shifting from European imports to regional offtake agreements (e.g., Dangote).</p>
          <div className="tag">Corridor Expansion</div>
        </div>

        <div className="strategy-card">
          <Layers className="text-accent" size={32} style={{ marginBottom: '1.5rem' }} />
          <h3>Product Diversification</h3>
          <p style={{ color: 'var(--cool-grey)', marginBottom: '1rem' }}>Integrating transition fuels (LPG/LNG) as a cleaner cooking alternative, and expanding into Marine Bunkering services (VLSFO) to meet the evolving global shipping demand at coastal hubs.</p>
          <div className="tag">Clean Energy Pivot</div>
        </div>

        <div className="strategy-card">
          <ShieldCheck className="text-accent" size={32} style={{ marginBottom: '1.5rem' }} />
          <h3>Financial & Currency Mitigation</h3>
          <p style={{ color: 'var(--cool-grey)', marginBottom: '1rem' }}>Active Brent hedging to protect margins against geopolitical tensions, utilizing back-to-back credit structures to manage local currency volatility against the USD.</p>
          <div className="tag">Risk Management</div>
        </div>

        <div className="strategy-card">
          <Cpu className="text-accent" size={32} style={{ marginBottom: '1.5rem' }} />
          <h3>Supply Chain Resilience</h3>
          <p style={{ color: 'var(--cool-grey)', marginBottom: '1rem' }}>Partnering with terminal operators for strategic tankage to buy low during gluts. Implementing real-time IoT tracking for chartered fleets to ensure transparent delivery windows.</p>
          <div className="tag">Digital Tracking</div>
        </div>
      </div>
    </div>
  </section>
);

const FutureProspects = () => (
  <section id="prospects" className="section section-alt">
    <div className="container">
      <div className="about-grid">
        <div className="about-text">
          <h2 className="section-title">Future Prospects & Innovation</h2>
          <div className="title-underline" style={{ margin: '0 0 2rem 0' }}></div>
          <p>
            With significant growth potential in the retail side of the African business and increasing demand for our LPG products, there are multiple opportunities for the company to expand in the years to come. South Africa offers amazing growth potential for businesses with a flexible supply chain and innovative approach.
          </p>
          
          <h4>Retail Expansion</h4>
          <p>
            We are actively looking to grow our retail network and market share. By looking for cross-border synergies, we aim to transition from our currently localized retail footprint to a dominant regional presence.
          </p>

          <h4>Strategic Collaborations</h4>
          <ul className="custom-list">
            <li><strong>Low-Carbon Synthetic Fuels:</strong> Partnering with local tech companies to develop commercial synthetic alternatives.</li>
            <li><strong>R&D Initiatives:</strong> Active collaborations with MVI Group and Bloomsberry Engineering to push scalable technology and differentiated production processes.</li>
          </ul>
        </div>
        
        <div className="vision-map" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <Network className="text-accent" size={64} style={{ margin: '0 auto 2rem auto' }} />
          <h3 style={{ color: 'var(--rose-gold)', marginBottom: '1rem' }}>Scalable Technology</h3>
          <p style={{ color: 'var(--cool-grey)', fontSize: '0.9rem' }}>
            Africa Growth competes with renewables and carbon engineering by focusing heavily on differentiated production processes.
          </p>
        </div>
      </div>
    </div>
  </section>
);

const Roadmap = () => {
  const roadmapData = [
    { q: 'Q1', title: 'Supply Consolidation', desc: 'Finalize offtake agreements with regional refineries (e.g. Dangote) to reduce reliance on non-African imports.' },
    { q: 'Q2', title: 'Trade Finance', desc: 'Secure a revolving credit facility (RCF) with a Pan-African bank (e.g., Afreximbank) for trade finance.' },
    { q: 'Q3', title: 'Technology Launch', desc: 'Launch a B2B portal for bulk buyers (mining, logistics firms) to track orders and pricing.' },
    { q: 'Q4', title: 'Retail Expansion', desc: 'Evaluate entry into the LPG retail market to diversify away from heavy industrial fuels.' }
  ];

  return (
    <section id="roadmap" className="section section-alt">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">2026 Strategic Roadmap</h2>
          <div className="title-underline"></div>
          <p style={{ color: 'var(--cool-grey)', marginTop: '1rem' }}>A disciplined approach to the "Big Wins" defining our fiscal year.</p>
        </div>
        
        <div className="roadmap-container">
          {roadmapData.map((item, idx) => (
            <div key={idx} className="roadmap-item">
              <div className="roadmap-q">{item.q}</div>
              <div className="roadmap-content">
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const Sustainability = () => (
  <section className="section">
    <div className="container">
      <div className="about-grid">
        <div className="about-text">
          <h2 className="section-title">Regulatory & Sustainability</h2>
          <div className="title-underline" style={{ margin: '0 0 2rem 0' }}></div>
          <p>Compliance is a competitive edge. We anticipate upcoming mandates for Ethanol and Biodiesel blending. As early adopters, we aim to secure government contracts and "green" financing.</p>
          <div style={{ display: 'flex', gap: '2rem', marginTop: '2rem' }}>
            <div style={{ textAlign: 'center' }}>
              <TrendingUp className="text-accent" size={32} />
              <p style={{ fontSize: '0.8rem', marginTop: '0.5rem' }}>AfCFTA Integration</p>
            </div>
            <div style={{ textAlign: 'center' }}>
              <Zap className="text-accent" size={32} />
              <p style={{ fontSize: '0.8rem', marginTop: '0.5rem' }}>Bio-fuel Blending</p>
            </div>
          </div>
        </div>
        <div className="vision-map">
          <h3 style={{ color: 'var(--rose-gold)', marginBottom: '1rem' }}>AfCFTA Protocols</h3>
          <p style={{ color: 'var(--cool-grey)', fontSize: '0.9rem' }}>We actively use the African Continental Free Trade Area protocols to reduce cross-border tariffs and simplify customs documentation, ensuring smooth logistics across all corridors.</p>
        </div>
      </div>
    </div>
  </section>
);

const About= () => {
  return (
 <div className="about-page">
      {/* --- Section 1: Who We Are --- */}
      <section id="about" className="section">
        <div className="container">
          <div className="section-header" style={{ textAlign: 'left' }}>
            <div className="tag">About Us</div>
            <h1 className="section-title" style={{ fontSize: '3.5rem' }}>Who We Are</h1>
            <p style={{ fontSize: '1.25rem', color: 'var(--cool-grey)', maxWidth: '900px', lineHeight: '1.8' }}>
              Africa Growth Group is a premier regional supplier and logistics operations group in the energy industry. We provide fuel, lubricants, risk management, and bespoke logistical solutions to dedicated clients across the SADC and Sub-Saharan energy value chains.
            </p>
          </div>

          <div className="about-grid" style={{ marginTop: '4rem' }}>
            <div>
              <h3 style={{ color: 'var(--rose-gold)', marginBottom: '1.5rem', fontSize: '1.5rem' }}>
                Regional Physical Supply and Trading Group
              </h3>
              <p>
                Originating from strategic hubs in Johannesburg, South Africa and Kitwe, Zambia, and Kampala Uganda, Africa Growth Group has developed long-standing relationships in its core markets of oil, lubricants, and refined products. 
              </p>
              <p style={{ marginTop: '1rem' }}>
                Leveraging the foundations of the Masinga Africa Group, we have expanded our operations to provide seamless energy solutions to landlocked nations and coastal corridors, bridging the gap between global supply and local demand with precision.
              </p>
            </div>
            <div>
              <h3 style={{ color: 'var(--rose-gold)', marginBottom: '1.5rem', fontSize: '1.5rem' }}>
                World-Class Executive Management
              </h3>
              <p>
                Our leadership team represents expert professionals formerly of major national mining and marketing sectors. Each director is a specialist in their respective field—from risk and strategy analysis, mining, finance, and energy to strategic public advocacy.
              </p>
              <p style={{ marginTop: '1rem' }}>
                With a combined experience of over 40 years in the SADC mining and energy landscape, our management ensures that every trade is backed by deep local intelligence and world-class standards.
              </p>
            </div>
          </div>

          {/* --- Slogan Section --- */}
          <div style={{ marginTop: '5rem', paddingTop: '4rem', borderTop: '1px solid var(--border-grey)' }}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '3rem', textAlign: 'center' }}>
              <div>
                <h3 style={{ fontSize: '2.5rem', color: 'var(--rose-gold)', marginBottom: '1rem', letterSpacing: '2px', fontFamily: 'Montserrat, sans-serif' }}>
                  SIMPLIFY.
                </h3>
                <p style={{ color: 'var(--cool-grey)', fontSize: '1.05rem', lineHeight: '1.6' }}>
                  We handle the complex logistics of cross-border fuel supply.
                </p>
              </div>
              
              <div>
                <h3 style={{ fontSize: '2.5rem', color: 'var(--rose-gold)', marginBottom: '1rem', letterSpacing: '2px', fontFamily: 'Montserrat, sans-serif' }}>
                  INNOVATE.
                </h3>
                <p style={{ color: 'var(--cool-grey)', fontSize: '1.05rem', lineHeight: '1.6' }}>
                  Using alliance partnerships and modern lubricants to drive sustainability.
                </p>
              </div>

              <div>
                <h3 style={{ fontSize: '2.5rem', color: 'var(--rose-gold)', marginBottom: '1rem', letterSpacing: '2px', fontFamily: 'Montserrat, sans-serif' }}>
                  SUCCEED.
                </h3>
                <p style={{ color: 'var(--cool-grey)', fontSize: '1.05rem', lineHeight: '1.6' }}>
                  Ensuring your fleet stays on the road and your business grows.
                </p>
              </div>
            </div>
          </div>

        </div>
      </section>
    


      <section className="section section-alt">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Growth & Financial Capacity</h2>
            <div className="title-underline"></div>
          </div>

          <div className="stat-grid">
            <div className="stat-card">
              <TrendingUp className="text-accent" style={{ marginBottom: '1rem' }} />
              <span className="stat-number">20+ Yrs</span>
              <span className="stat-label">Regional Expertise</span>
            </div>
            <div className="stat-card">
              <BarChart3 className="text-accent" style={{ marginBottom: '1rem' }} />
              <span className="stat-number">Asset-Light</span>
              <span className="stat-label">Efficient Capital Cycle</span>
            </div>
            <div className="stat-card">
              <Globe className="text-accent" style={{ marginBottom: '1rem' }} />
              <span className="stat-number">100%</span>
              <span className="stat-label">African Footprint</span>
            </div>
          </div>

          <p style={{ textAlign: 'center', maxWidth: '800px', margin: '0 auto', color: 'var(--cool-grey)' }}>
            Our financial resilience is highlighted by a disciplined, asset-light business model. We focus on high-liquidity current assets and strategic storage partnerships, allowing us to navigate the volatility of the 2026 energy market while maintaining strong trade finance facilities with Pan-African institutions.
          </p>
        </div>
      </section>

      {/* --- Section 3: Risk & Compliance --- */}
      <section className="section">
        <div className="container">
          <div className="compliance-box">
            <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem', marginBottom: '2rem' }}>
              <ShieldCheck className="text-accent" size={48} />
              <h2 style={{ fontSize: '2rem' }}>Culture of Disciplined Risk Management</h2>
            </div>
            <div className="about-grid" style={{ gap: '3rem' }}>
              <div>
                <p>
                  We implement strict risk management policies and procedures, highlighted by the maintenance of diligent relationships with business partners and customers.
                </p>
                <p style={{ marginTop: '1rem' }}>
                  In a complex geopolitical climate, our <strong>"Back-to-Back"</strong> credit structures and <strong>Brent Price Hedging</strong> strategies are non-negotiable standards that protect our margins and our clients' supply security.
                </p>
              </div>
              <div>
                <ul className="custom-list">
                  <li>Full compliance with AfCFTA cross-border protocols.</li>
                  <li>Strict adherence to international safety and environmental standards.</li>
                  <li>Real-time IoT tracking for 100% supply chain transparency.</li>
                  <li>Diligent vetting of all alliance and logistical partners.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --- Section 4: Mission, Vision, Values --- */}
      <section className="section section-alt">
        <div className="container">
          <div className="vision-mission-box" style={{ marginTop: 0 }}>
            <div>
              <div className="tag">Our Mission</div>
              <h3 style={{ marginBottom: '1rem' }}>Tailored Energy Solutions</h3>
              <p>
                To provide our regional energy customers with perfectly tailored solutions using our unique, bespoke logistics, risk management, and finance packages.
              </p>
            </div>
            <div style={{ borderLeft: '1px solid var(--border-grey)', paddingLeft: '3rem' }}>
              <div className="tag">Our Vision</div>
              <h3 style={{ marginBottom: '1rem' }}>Reliable Stability</h3>
              <p>
                To deliver a stable and reliable supply of fuel, gas, and distillates, specifically tailored to the infrastructure and community needs of Sub-Saharan Africa.
              </p>
            </div>
          </div>

          <div style={{ marginTop: '6rem', textAlign: 'center' }}>
            <h2 className="section-title">Our Values</h2>
            <div className="title-underline"></div>
            <div className="strategy-grid" style={{ marginTop: '3rem' }}>
              <div className="strategy-card">
                <CheckCircle className="text-accent" style={{ marginBottom: '1rem' }} />
                <h4>Take Responsibility</h4>
                <p style={{ fontSize: '0.9rem' }}>Meeting every obligation, commitment, and agreement, every time.</p>
              </div>
              <div className="strategy-card">
                <Users className="text-accent" style={{ marginBottom: '1rem' }} />
                <h4>Communicate</h4>
                <p style={{ fontSize: '0.9rem' }}>Fast, clear collaboration and knowledge sharing with our clients.</p>
              </div>
              <div className="strategy-card">
                <Award className="text-accent" style={{ marginBottom: '1rem' }} />
                <h4>Be Passionate</h4>
                <p style={{ fontSize: '0.9rem' }}>Working enthusiastically to make every project an industry benchmark.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

const ServicesAndProducts = () => {
  return (
    <section id="products-services" className="section">
      <div className="container">
        {/* --- Header --- */}
        <div className="section-header">
          <h2 className="section-title">Products & Services</h2>
          <div className="title-underline"></div>
          <p style={{ maxWidth: '800px', margin: '1.5rem auto', color: 'var(--cool-grey)' }}>
            Leveraging strategic alliances and innovative technology to provide safer, smarter, and more cost-effective energy solutions across the African continent.
          </p>
        </div>

        {/* --- Category 1: Energy Commodities (Physical Products) --- */}
        <div style={{ marginTop: '4rem' }}>
          <h3 style={{ color: 'var(--rose-gold)', fontSize: '1.2rem', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '2rem' }}>
            01. Energy Commodities
          </h3>
          <div className="strategy-grid">
            <div className="strategy-card">
              <Droplet className="text-accent" size={32} style={{ marginBottom: '1rem' }} />
              <h4>Transportation Fuels</h4>
              <p style={{ fontSize: '0.9rem', color: 'var(--cool-grey)' }}>
                High-volume supply of Diesel (50/500PPM) and Petrol (93/95-ULP/LRP) for commercial and industrial fleets.
              </p>
            </div>
            
            <div className="strategy-card">
              <Plane className="text-accent" size={32} style={{ marginBottom: '1rem' }} />
              <h4>Aviation & JP54</h4>
              <p style={{ fontSize: '0.9rem', color: 'var(--cool-grey)' }}>
                Licensed supply of Aviation Gasoline (AVGAZ), Jet Fuel (Jet A1), and specialized JP54 fuels.
              </p>
            </div>

            <div className="strategy-card">
              <Zap className="text-accent" size={32} style={{ marginBottom: '1rem' }} />
              <h4>Gaseous Fuels</h4>
              <p style={{ fontSize: '0.9rem', color: 'var(--cool-grey)' }}>
                Liquefied Petroleum Gas (LPG) and Liquefied Natural Gas (LNG) for industrial heating and commercial use.
              </p>
            </div>

            <div className="strategy-card">
              <Construction className="text-accent" size={32} style={{ marginBottom: '1rem' }} />
              <h4>Black Products</h4>
              <p style={{ fontSize: '0.9rem', color: 'var(--cool-grey)' }}>
                High-grade Bitumen and Asphalt for regional road development and infrastructure projects.
              </p>
            </div>
          </div>
        </div>

        {/* --- Category 2: Specialized Services & Tech --- */}
        <div style={{ marginTop: '5rem' }}>
          <h3 style={{ color: 'var(--rose-gold)', fontSize: '1.2rem', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '2rem' }}>
            02. Integrated Industrial Services
          </h3>
          <div className="strategy-grid">
            <div className="strategy-card">
              <Truck className="text-accent" size={32} style={{ marginBottom: '1rem' }} />
              <h4>Transport & Logistics</h4>
              <p style={{ fontSize: '0.9rem', color: 'var(--cool-grey)' }}>
                Precision-timed delivery of fuels and lubricants to depots and transporters across Sub-Saharan Africa.
              </p>
            </div>

            <div className="strategy-card">
              <Settings className="text-accent" size={32} style={{ marginBottom: '1rem' }} />
              <h4>Automated Solutions</h4>
              <p style={{ fontSize: '0.9rem', color: 'var(--cool-grey)' }}>
                Innovative technology-driven fuel delivery and distribution services to streamline client operations.
              </p>
            </div>

            <div className="strategy-card">
              <Layers className="text-accent" size={32} style={{ marginBottom: '1rem' }} />
              <h4>Specialized Lubricants</h4>
              <p style={{ fontSize: '0.9rem', color: 'var(--cool-grey)' }}>
                Comprehensive range of Automobile, Aviation, and Industrial lubricants for high-performance machinery.
              </p>
            </div>

            <div className="strategy-card">
              <Leaf className="text-accent" size={32} style={{ marginBottom: '1rem' }} />
              <h4>Low-Carbon Initiatives</h4>
              <p style={{ fontSize: '0.9rem', color: 'var(--cool-grey)' }}>
                Development and commercialization of low-carbon synthetic fuels in partnership with industry innovators.
              </p>
            </div>
          </div>
        </div>

        {/* --- Target Markets / Footer Section --- */}
        <div className="compliance-box" style={{ marginTop: '5rem', padding: '3rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
            <Target className="text-accent" size={24} />
            <h3 style={{ margin: 0 }}>Target Markets</h3>
          </div>
          <p style={{ color: 'var(--cool-grey)', marginBottom: '2rem' }}>
            Our solutions are specifically engineered for high-demand sectors requiring reliable energy supply chains:
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1.5rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', fontSize: '0.9rem' }}>
              <ShieldCheck className="text-accent" size={16} /> Bulk Fuel & Gas Consumers
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', fontSize: '0.9rem' }}>
              <ShieldCheck className="text-accent" size={16} /> Heavy Industrial Sectors
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', fontSize: '0.9rem' }}>
              <ShieldCheck className="text-accent" size={16} /> Petroleum Wholesalers
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', fontSize: '0.9rem' }}>
              <ShieldCheck className="text-accent" size={16} /> Government & Private Orgs
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const OurBusiness = () => (
  <section id="business" className="section">
    <div className="container">
      <div className="section-header">
        <h2 className="section-title">Our Business</h2>
        <div className="title-underline"></div>
      </div>
      
      <div className="about-grid" style={{ alignItems: 'center' }}>
        <div className="about-text">
          <p style={{ fontSize: '1.15rem', color: 'var(--white)', fontWeight: '500', marginBottom: '1.5rem' }}>
            Africa Growth Group is a fuel and lubricant trading and supply company specialising in the supply of fuel and other necessary products to depots and transporters travelling through Southern Africa.
          </p>
          <p style={{ color: 'var(--cool-grey)' }}>
            With the exponential growth of Africa, we support the need to serve the communities that are being built across a wide and diverse region with all its special needs and expectations.
          </p>
          {/* Note: The old redundant paragraph was removed here to let the new section shine. */}
        </div>
        
        <div className="strategy-grid" style={{ marginTop: 0 }}>
          <div className="strategy-card" style={{ padding: '1.5rem' }}>
            <Truck className="text-accent" size={24} style={{ marginBottom: '1rem' }} />
            <h4 style={{ color: 'var(--white)', marginBottom: '0.5rem' }}>Precision Logistics</h4>
            <p style={{ fontSize: '0.85rem', color: 'var(--cool-grey)' }}>Specialized supply for depots and transporters across SADC.</p>
          </div>
          <div className="strategy-card" style={{ padding: '1.5rem' }}>
            <Users className="text-accent" size={24} style={{ marginBottom: '1rem' }} />
            <h4 style={{ color: 'var(--white)', marginBottom: '0.5rem' }}>Community Impact</h4>
            <p style={{ fontSize: '0.85rem', color: 'var(--cool-grey)' }}>Driving job creation and social stability through energy access.</p>
          </div>
          <div className="strategy-card" style={{ padding: '1.5rem' }}>
            <Handshake className="text-accent" size={24} style={{ marginBottom: '1rem' }} />
            <h4 style={{ color: 'var(--white)', marginBottom: '0.5rem' }}>Alliance Network</h4>
            <p style={{ fontSize: '0.85rem', color: 'var(--cool-grey)' }}>Industry-leading partnerships ensuring on-time excellence.</p>
          </div>
        </div>
      </div>

      {/* --- NEW HIGHLIGHT SECTION: Precision in Motion --- */}
      <div style={{ 
        marginTop: '4rem', 
        padding: '3rem', 
        background: 'linear-gradient(135deg, rgba(200, 129, 95, 0.08) 0%, rgba(20, 20, 22, 0.4) 100%)', 
        borderLeft: '4px solid var(--rose-gold)', /* adjust to var(--copper) if using the newer palette */
        borderRadius: '0 15px 15px 0',
        boxShadow: '0 10px 30px rgba(0,0,0,0.2)'
      }}>
        <h3 style={{ fontSize: '1.8rem', color: 'var(--rose-gold)', marginBottom: '1rem', letterSpacing: '1px' }}>
          Precision in Motion
        </h3>
        <p style={{ fontSize: '1.15rem', color: 'var(--white)', marginBottom: '1rem', fontStyle: 'italic', lineHeight: '1.6' }}>
          Through our elite alliance partnerships with industry leaders, we have cultivated far-reaching capabilities. We don't just deliver products; we deliver certainty. <span style={{ color: 'var(--rose-gold)', fontWeight: 'bold' }}>"In time, on time, every time."</span>
        </p>
        <p style={{ color: 'var(--cool-grey)', fontSize: '1rem', lineHeight: '1.6' }}>
          By upholding these standards, Africa Growth Group is helping to create a more stable social and economic climate—one delivery, one corridor, and one community at a time.
        </p>
      </div>
    </div>
  </section>
);


export const CorridorMap = () => {
  const [activeRoute, setActiveRoute] = useState('sadc');

  return (
    <section id="map" className="section">
      <div className="container">
        <div className="section-header">
          <div className="tag">Logistical Reach</div>
          <h2 className="section-title">African Supply Corridors</h2>
          <div className="title-underline"></div>
          <p style={{ marginTop: '1rem', color: 'var(--cool-grey)' }}>
            Explore our supply routes bridging South African hubs with landlocked nations and optimizing East African port entries.
          </p>
        </div>

        <div className="map-container">
          {/* Sidebar Controls */}
          <div className="map-sidebar">
            <h4 style={{ color: 'var(--rose-gold)', marginBottom: '1rem' }}>Select Route</h4>
            <button className={`map-btn ${activeRoute === 'sadc' ? 'active' : ''}`} onClick={() => setActiveRoute('sadc')}>
              <Map size={16} style={{ display: 'inline', marginRight: '8px' }} /> SADC Hub (Zim, Zam, Bots)
            </button>
            <button className={`map-btn ${activeRoute === 'east' ? 'active' : ''}`} onClick={() => setActiveRoute('east')}>
              <Anchor size={16} style={{ display: 'inline', marginRight: '8px' }} /> East African Ports (Beira, Dar)
            </button>
            <button className={`map-btn ${activeRoute === 'west' ? 'active' : ''}`} onClick={() => setActiveRoute('west')}>
              <Truck size={16} style={{ display: 'inline', marginRight: '8px' }} /> West African Refining Pivot
            </button>
          </div>

          {/* Map Visual Placeholder - In a real app, integrate Mapbox, Leaflet, or D3.js here */}
          <div style={{ textAlign: 'center', color: 'var(--cool-grey)' }}>
            <Globe size={120} opacity={0.2} style={{ margin: '0 auto 1rem auto', color: 'var(--rose-gold)' }} />
            <h3>Interactive Map Interface</h3>
            <p style={{ maxWidth: '400px', margin: '0 auto' }}>
              {activeRoute === 'sadc' && "Visualizing South African supply lines feeding directly into Zimbabwe, Zambia, and Botswana. Highlighting strategic storage nodes."}
              {activeRoute === 'east' && "Visualizing port optimizations at Beira (Mozambique) and Dar es Salaam (Tanzania), bypassing traditional West African congestion."}
              {activeRoute === 'west' && "Visualizing new regional offtake agreements with West African refineries, significantly reducing transit times."}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

// ==========================================
// 2. Market Intelligence & Insights
// ==========================================
export const MarketIntelligence = () => (
  <section id="intelligence" className="section section-alt">
    <div className="container">
      <div className="section-header">
        <div className="tag">Market Intelligence</div>
        <h2 className="section-title">Regional Insights & Data</h2>
        <div className="title-underline"></div>
      </div>

      <div className="market-dashboard">
        <div>
          <h3 style={{ color: 'var(--white)', marginBottom: '1.5rem' }}><LineChart className="text-accent" style={{ display: 'inline', marginRight: '10px' }}/> Live Indicators</h3>
          <div className="market-ticker" style={{ flexDirection: 'column', gap: '1.5rem', border: 'none' }}>
            <div className="ticker-item" style={{ textAlign: 'left' }}>
              <span className="ticker-label">Brent Crude (ICE)</span>
              <div className="ticker-price">$84.32 <span style={{ fontSize: '1rem', color: '#4ade80' }}>+1.2%</span></div>
            </div>
            <div className="ticker-item" style={{ textAlign: 'left' }}>
              <span className="ticker-label">ZAR / USD</span>
              <div className="ticker-price">R 18.45 <span style={{ fontSize: '1rem', color: '#f87171' }}>-0.4%</span></div>
            </div>
            <div className="ticker-item" style={{ textAlign: 'left' }}>
              <span className="ticker-label">Gasoil 50ppm (Durban)</span>
              <div className="ticker-price">Stable Supply</div>
            </div>
          </div>
        </div>
        
        <div style={{ borderLeft: '1px solid var(--border-grey)', paddingLeft: '2rem' }}>
          <h3 style={{ color: 'var(--rose-gold)', marginBottom: '1rem' }}>Weekly Market Briefing</h3>
          <div style={{ marginBottom: '1.5rem' }}>
            <h4 style={{ color: 'var(--white)', marginBottom: '0.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <AlertCircle size={16} className="text-accent" /> Geopolitical Impact on Supply
            </h4>
            <p style={{ color: 'var(--cool-grey)', fontSize: '0.9rem' }}>
              Current Middle East tensions impacting the Strait of Hormuz necessitate active Brent price hedging. Africa Growth has secured strategic tankage at East African ports to buffer against potential global gluts or local shortages, ensuring uninterrupted supply to the SADC region.
            </p>
          </div>
          <div>
            <h4 style={{ color: 'var(--white)', marginBottom: '0.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <TrendingUp size={16} className="text-accent" /> AfCFTA Tariff Reductions
            </h4>
            <p style={{ color: 'var(--cool-grey)', fontSize: '0.9rem' }}>
              We are actively integrating African Continental Free Trade Area protocols to reduce cross-border tariffs. This simplifies customs documentation, accelerating turnaround times for commercial transport fleets navigating landlocked corridors.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

// ==========================================
// 3. Sustainability & ESG (The Green Pivot)
// ==========================================
export const SustainabilityESG = () => (
  <section id="esg" className="section">
    <div className="container">
      <div className="about-grid">
        <div className="about-text">
          <div className="tag">The Green Pivot</div>
          <h2 className="section-title" style={{ textAlign: 'left', marginBottom: '1rem' }}>Sustainability & ESG</h2>
          <div className="title-underline" style={{ margin: '0 0 2rem 0' }}></div>
          <p>
            Environmental, Social, and Governance (ESG) criteria are embedded into our execution strategy. As governments introduce mandates for cleaner energy, Africa Growth is positioned as an early adopter to secure "green" financing and pioneer sustainable logistics.
          </p>
          
          <div style={{ marginTop: '2rem' }}>
            <h4 style={{ color: 'var(--rose-gold)' }}>Bio-Fuel Blending & R&D</h4>
            <p style={{ color: 'var(--cool-grey)' }}>
              We are actively anticipating regional mandates for Ethanol and Biodiesel blending. Through partnerships with <strong>MVI Group and Bloomsberry Engineering</strong>, we are co-developing and commercializing low-carbon synthetic fuels[cite: 88].
            </p>
          </div>
        </div>

        <div className="vision-map" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <Leaf className="text-accent" size={64} style={{ margin: '0 auto 2rem auto' }} />
          <h3 style={{ color: 'var(--rose-gold)', marginBottom: '1rem' }}>The Social Climate</h3>
          <p style={{ color: 'var(--cool-grey)', fontSize: '0.9rem' }}>
            Our logistics network does more than move fuel. The operations and deliveries we manage help create sustainable jobs, fostering a stable economic and social climate in the communities being built across Southern Africa[cite: 23].
          </p>
        </div>
      </div>
    </div>
  </section>
);

// ==========================================
// 4. Social Responsibility & Values Page
// ==========================================
export const SocialResponsibility = () => (
  <section id="responsibility" className="section section-alt">
    <div className="container">
      <div className="section-header">
        <div className="tag">Our Commitment</div>
        <h2 className="section-title">Corporate & Social Responsibility</h2>
        <div className="title-underline"></div>
        <p style={{ maxWidth: '800px', margin: '1.5rem auto', color: 'var(--cool-grey)' }}>
          At Africa Growth, our success is intrinsically linked to the well-being of the continent. We conduct our business in full compliance with international standards, prioritizing the dignity of our people and the health of our environment.
        </p>
      </div>

      <div className="strategy-grid" style={{ marginTop: '3rem' }}>
        
        {/* Dignity & Respect */}
        <div className="strategy-card">
          <Heart className="text-accent" size={32} style={{ marginBottom: '1.5rem' }} />
          <h3>Dignity & Respect</h3>
          <p style={{ color: 'var(--cool-grey)', fontSize: '0.9rem', marginBottom: '1rem' }}>
            We believe our people and partners are our most important assets. We remain humble, prioritizing customer service and remembering the communities that got us where we are today[cite: 90, 91, 92]. We foster a workplace free of discrimination, sharing our joy and success with employees, collaborators, and clients[cite: 104].
          </p>
        </div>

        {/* Health, Safety & Communities */}
        <div className="strategy-card">
          <ShieldCheck className="text-accent" size={32} style={{ marginBottom: '1.5rem' }} />
          <h3>Health, Safety & Communities</h3>
          <p style={{ color: 'var(--cool-grey)', fontSize: '0.9rem', marginBottom: '1rem' }}>
            Preserving human health and safety is paramount. We design safety-centric fueling solutions and aim to introduce safer, cleaner fuels to the market[cite: 95, 109]. Beyond energy, we champion community welfare through initiatives like the <strong>Bloomsberry Foundation</strong>, focusing on vital Water and Sanitation projects across the SADC region.
          </p>
        </div>

        {/* Ethics & Conduct */}
        <div className="strategy-card">
          <CheckCircle className="text-accent" size={32} style={{ marginBottom: '1.5rem' }} />
          <h3>Business Ethics & Conduct</h3>
          <p style={{ color: 'var(--cool-grey)', fontSize: '0.9rem', marginBottom: '1rem' }}>
            Our operations are guided by the principle of <strong>Taking Responsibility</strong>. Every employee is expected to meet their obligations and agreements, communicating clearly with all stakeholders[cite: 102]. We share knowledge and resources not just for commercial goals, but to ensure every interaction leaves the world better[cite: 104].
          </p>
        </div>

      </div>
    </div>
  </section>
);

const Footer = () => (
  <footer id="contact" className="footer">
    <div className="container">
      <div className="footer-grid">
        <div>
          <h2 className="section-title" style={{ textAlign: 'left', marginBottom: '1rem' }}>Trade Desk</h2>
          <div className="title-underline" style={{ margin: '0 0 2rem 0' }}></div>
          <p style={{ color: 'var(--cool-grey)', marginBottom: '2rem' }}>Ready to discuss bulk supply, hedging strategies, or regional logistics alliances?</p>
          <div className="contact-info">
            <p><MapPin className="text-accent" size={20} /> 
            3044 Lilongwe Road, Kitwe, Zambia 
            <br/> 
            Office 2 Blueberry St, Honeydew, South Africa 
            <br/>
             P.O. box 1270, Kampala, Uganda  
            </p>
            <p><Phone className="text-accent" size={20} /> +260 96 457 5846 / +27 84 596 2424</p>
            <p><Mail className="text-accent" size={20} /> info@africagrowthgroup.co.za</p>
          </div>
        </div>
       
      </div>
      <div className="footer-bottom">
        &copy; {new Date().getFullYear()} Africa Growth Group | Simplify. Innovate. Succeed.
      </div>
    </div>
  </footer>
);

export default function App() {
  return (
    <div>
      <Navbar />
      <Hero />
      <Identity />
      <About/>
      <ImageDivider image={silhuette_oil_rig}/>
      <OurBusiness/>
      <Strategy />
      <ImageDivider image={oil_truck}/>
      <ServicesAndProducts/>
      
      <SocialResponsibility/>
      <SustainabilityESG/>
      <FutureProspects />
      <Footer />
    </div>
  );
}